import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf } from '@fortawesome/pro-duotone-svg-icons';

import { Typography } from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { useProcessarIacea } from '../hooks/useProcessarIacea';

interface TranscricaoEmAndamentoCardProps {
  onError?: (title: string, message: string) => void;
}

const TranscricaoEmAndamentoCard: React.FC<TranscricaoEmAndamentoCardProps> = ({ onError }) => {
  const accessibility = useAccessibility();
  useProcessarIacea({ onError });

  return (
    <div className="transcricao-em-andamento-card" aria-live="polite" aria-atomic="true">
      <div className="transcricao-em-andamento-conteudo">
        <div className="transcricao-em-andamento-icon" aria-hidden="true">
          <FontAwesomeIcon
            icon={faHourglassHalf}
            spin
            className="transcricao-em-andamento-icon-svg"
          />
        </div>
        <div className="transcricao-em-andamento-texto">
          <Typography
            style={accessibility.textStyleAccessibility}
            className="transcricao-em-andamento-titulo"
          >
            <strong>Revisão de dados</strong>
          </Typography>
          <Typography
            style={accessibility.textStyleAccessibility}
            className="transcricao-em-andamento-subtitulo"
          >
            Analisando cada detalhe do documento para assegurar a precisão das informações. Por
            favor, aguarde.
          </Typography>
          <Typography
            style={accessibility.textStyleAccessibility}
            className="transcricao-em-andamento-tempo"
          >
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default TranscricaoEmAndamentoCard;
